window.addEventListener("pageshow", function (event) {
    pageTransition.enter(function () {
        $(window).trigger('transitionDone');
    });
});